import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import Modal from './Modal';

import '../assets/styles/components/Banner.sass';

class Banner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      open: false,
      id: null,
      bannerHeight: 0,
    }

    this.modalStatus = this.modalStatus.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.setLocalStorage = this.setLocalStorage.bind(this);
    this.getBanner = this.getBanner.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }
  
  componentDidMount() {
    this.setState({
      id: this.props.id
    }, () => this.getBanner());
    this.setState({
      bannerHeight: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) * 38 / 100
    })

    window.addEventListener('resize', this.handleResize);
    document.addEventListener("keydown", this.handleKeyDown, false);
  }

  componentWillReceiveProps(nextProps) {
    const ID = nextProps.id;
    if(this.state.id !== ID) {
      this.setState({
        id: ID
      }, () => this.getBanner());
    }
  }

  componentDidUpdate() {
    const btnAction = document.getElementById('btnModalStatus');
    if (btnAction) {
      btnAction.addEventListener('click', this.modalStatus, false);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener("keydown", this.handleKeyDown, false);
    const btnModalStatus = document.getElementById('btnModalStatus');
    if (btnModalStatus) {
      btnModalStatus.removeEventListener('click', this.modalStatus, false);
    }
  }

  getBanner() {
    const Banner = window.sessionStorage.getItem(`banner-${this.state.id}`);
    if (Banner) {
      this.setState({
        data: JSON.parse(window.sessionStorage.getItem(`banner-${this.state.id}`))
      });
    } else {
      fetch(`${process.env.REACT_APP_URL}/api/adventures/banner/${this.state.id}`)
      .then(res => res.json())
      .then((res) => {
          this.setLocalStorage(res[0]);
        }
      )
    }
    return;
  }

  setLocalStorage(banner) {
    try {
      window.sessionStorage.setItem(`banner-${this.state.id}`, JSON.stringify(banner));
      this.setState({
        data: banner
      });
    } catch (error) {
      console.error(error);
    }
    return;
  }

  modalStatus() {
    this.setState({
      open: !this.state.open
    });
  }

  handleKeyDown(e) {
    if (e.keyCode === 27) {
      this.setState({
        open: false
      })
    }
  };

  handleResize() {
    this.setState({
      bannerHeight: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) * 38 / 100
    })
  }

  render() {
    if (this.state.data.foto_en === undefined) {
      return null
    };

    return (
      <>
        <div className="row">
          <div className={`col-12 banner --${this.props.city} --lineBottom-${this.props.lineBottom}`} style={{height: this.state.bannerHeight}}>
            <aside>
              {this.state.data.enlace_es ?
                <a href={this.state.data.enlace_es} title="La Leyenda Adventures"> 
                  <img className="img-fluid" src={`https://la-leyenda.com/2018/en/img/banner/${this.state.data.foto_es}`} alt="" />
                </a> : 
                <img className="img-fluid" src={`https://la-leyenda.com/2018/en/img/banner/${this.state.data.foto_es}`} alt="" />
              }
              <div className="banner__actions">
                <figure>
                  <img src={`https://la-leyenda.com/adventures/img/${this.props.thumb}`} alt="La Leyenda Adventures"/>
                </figure>

                { ReactHtmlParser(this.state.data.content_es) }

              </div>
            </aside>
          </div>
        </div>
  
        {this.state.open &&
          <Modal close={this.modalStatus}/>
        }
      </>
    ) 
  }
}

export default React.memo(Banner);
